import classNames from '@components/utils/classNames'
import { Fragment, useEffect, useState } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { GENERAL_SORT } from '@components/utils/textVariables'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { recordGA4Event } from '@components/services/analytics/ga4'
import { Check } from '@components/icons'
interface Props {
  products: any
  action: any
  routerSortOption: any
  swrLoading: any
}

interface ISortItem {
  key: string
  value: string
  eventValue: string
}

export default function ProductSort({
  action,
  routerSortOption,
  swrLoading = false,
}: Props) {
  const [currentOption, setCurrentOption] = useState<any>({})

  const sortItems: ISortItem[] = [
    {
      key: '',
      value: 'Relevance',
      eventValue: 'sort:relevance',
    },
    {
      key: '1',
      value: 'Price : Low to High',
      eventValue: 'sort:price_low_to_high',
    },
    {
      key: '2',
      value: 'Price : High to Low',
      eventValue: 'sort:price_high_to_low',
    },
    {
      key: '6',
      value: 'Discount',
      eventValue: 'sort:discount',
    },
  ]

  useEffect(() => {
    setCurrentOption(
      sortItems?.filter((item: any) => item.key === routerSortOption)[0]
    )
  }, [routerSortOption])

  const handleSortGAEvent = (filter_applied: string) => {
    recordGA4Event(window, GA_EVENT.SORT_AND_FILTER, {
      action: 'sort',
      filter_applied: filter_applied,
    })
  }

  return (
    <Menu as="div" className="relative sm:inline-block sm:mr-3">
      <div className="flex">
        <Menu.Button className="inline-flex rounded-lg justify-center py-1 pl-2 pr-5 text-sm font-medium text-gray-700 border border-gray-300 outline-none group hover:text-gray-900">
          <span className="pr-1 font-normal text-black">
            <span className="font-light">{GENERAL_SORT}</span>
            {': '}{' '}
          </span>{' '}
          {currentOption?.value}
          <span
            className="relative flex-shrink-0 inline-block ml-1 -mr-3 leading-none text-gray-800 top-2/4 -translate-y-2/4 group-hover:text-orange line-height-0"
            aria-hidden="true"
          >
            <i className="leading-none sprite-icon sprite-down"></i>
          </span>
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-2 text-left origin-top-right bg-white rounded-md shadow-2xl outline-none z-99 ring-1 ring-black ring-opacity-5 focus:outline-none w-60">
          <div className="py-1">
            {sortItems?.length > 0 &&
              sortItems?.map((option: ISortItem) => (
                <Menu.Item key={option.value}>
                  {({ active, close }) => (
                    <div>
                      {/* <Link
                        legacyBehavior
                        href={{
                          pathname: router.pathname,
                          query: {
                            ...router.query,
                            sortBy: option.key,
                          },
                        }}
                        passHref
                      > */}
                      <span
                        onClick={() => {
                          handleSortGAEvent(option.eventValue)
                          action(option.key)
                          close()
                        }}
                        className={classNames(
                          'text-gray-dark hover:bg-gray-100',
                          currentOption?.key === option.key
                            ? 'bg-selected-sort'
                            : '',
                          'block px-4 py-2 text-sm relative'
                        )}
                      >
                        {option.value}
                        <span
                          className={classNames(
                            'w-5 h-5 rounded-full border border-gray-100 bg-gray-200 flex absolute top-2 right-2 items-center justify-center',
                            currentOption?.key === option.key
                              ? 'bg-primary'
                              : '',
                            'w-5 h-5 rounded-full border border-gray-100 bg-gray-200 flex absolute top-2 right-2 items-center justify-center'
                          )}
                        >
                          <Check
                            className={classNames(
                              ' text-gray-200 w-4 h-4 text-sm font-bold',
                              currentOption?.key === option.key
                                ? 'w-3 h-3 text-white text-sm '
                                : '',
                              'text-gray-200 w-4 h-4 text-sm font-bold'
                            )}
                          />
                        </span>
                      </span>
                      {/* </Link> */}
                    </div>
                  )}
                </Menu.Item>
              ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
